export const FeatureFlagState = {
  Disabled: 0,
  Enabled: 1,
  AdminOnly: 2,
};
